export default __webpack_public_path__ + "3202d9db099f3303960f6f641bc8045e.svg";